module.exports = __webpack_public_path__ + "img/24_13.24ee7f13.png";